function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5147 11.7017C24.7622 11.7017 23.7654 11.685 22.5244 11.685C19.4978 11.685 17.0092 9.18 17.0092 6.125V0.765C17.0092 0.343333 16.6726 0 16.2551 0H7.43938C3.32528 0 0 3.37667 0 7.515V25.4733C0 29.815 3.4837 33.3333 7.78263 33.3333H20.9105C25.0097 33.3333 28.3333 29.9783 28.3333 25.8367V12.4517C28.3333 12.0283 27.9983 11.6867 27.5792 11.6883C26.8745 11.6933 26.0296 11.7017 25.5147 11.7017Z",
  fill: "#EB5757"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9738 0.944965C20.4755 0.426632 19.6055 0.783299 19.6055 1.50163V5.89663C19.6055 7.73996 21.1238 9.25663 22.9671 9.25663C24.1288 9.26997 25.7421 9.2733 27.1121 9.26997C27.8138 9.2683 28.1705 8.42997 27.6838 7.9233C25.9255 6.09496 22.7771 2.8183 20.9738 0.944965Z",
  fill: "#EB5757"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9104 18.1537L16.9454 16.1171C17.4304 15.6337 17.4304 14.8487 16.9454 14.3638C16.4604 13.8787 15.6754 13.8787 15.1904 14.3638L13.1554 16.3971L11.1204 14.3638C10.6354 13.8787 9.84875 13.8787 9.36375 14.3638C8.87875 14.8487 8.87875 15.6337 9.36375 16.1171L11.4004 18.1537L9.36375 20.1887C8.87875 20.6737 8.87875 21.4588 9.36375 21.9421C9.60708 22.1854 9.92375 22.3071 10.2421 22.3071C10.5604 22.3071 10.8771 22.1854 11.1204 21.9421L13.1554 19.9087L15.1904 21.9421C15.4321 22.1854 15.7504 22.3071 16.0687 22.3071C16.3854 22.3071 16.7038 22.1854 16.9454 21.9421C17.4304 21.4588 17.4304 20.6737 16.9454 20.1887L14.9104 18.1537Z",
  fill: "white"
});

function SvgPaperDeclined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperDeclined);
export default __webpack_public_path__ + "static/media/paperDeclined.bac95522ff978cd34c5994f45d421bdc.svg";
export { ForwardRef as ReactComponent };